angular.module('SpidApp')

.factory('GenericFlusherSyncServiceFactory',
        ['$http', 'SyncConfig', 'Chunker', '$q',
function ($http,   SyncConfig,   Chunker,   $q) {
  var GenericFlusherSyncServiceFactory = function (params) {
      var nodePushUrl = SyncConfig.Node.getURLFor(params.nodePushUrl)
      var nodeAuthorization = SyncConfig.Node.Authorization

      var distantUrl = SyncConfig.Distant.getURLFor(params.distantUrl)
      var distantAuthorization = SyncConfig.Distant.Authorization

      var Service = {
        Node: {
          pushAll: function (elems) {
            var req = { method: 'DELETE', url: nodePushUrl, headers: { 'Authorization': nodeAuthorization } }
            return $http(req).then(function(){
                var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
                var pools = []
                for(var i = 0 ; i < chunked.length ; i++) {
                    var data = chunked[i]
                    var post = { method: 'POST', url: nodePushUrl, headers: { 'Authorization': nodeAuthorization }, data: data }
                    pools.push($http(post))
                }
                return $q.all(pools)
            }).then(function () {
                return {something: 'OK'}
            })
          }
        },
        Distant: {
          getAllUnsync: function () {
            var req = { method: 'GET', url: distantUrl, headers: { 'Authorization': distantAuthorization } }

            return $http(req).then(function (response) {
              return response.data
            })
          }
        }
      }

      return Service
  }
  
  return GenericFlusherSyncServiceFactory
}])